import Table from '@tiptap/extension-table';

/**
 * Extended Table extension that reads column widths from <colgroup> elements
 * and applies them to cell colwidth attributes, allowing widths to persist
 * through the HTML → Markdown → HTML conversion cycle.
 */
export const TableWithColgroup = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
    };
  },

  parseHTML() {
    return [
      {
        tag: 'table',
        getAttrs: (node) => {
          // Extract colgroup widths and store them temporarily
          // We'll apply them to cells in the parseHTML of TableCell/TableHeader
          if (typeof node === 'string') return null;
          
          const element = node as HTMLElement;
          const colgroup = element.querySelector('colgroup');
          
          if (colgroup) {
            const cols = colgroup.querySelectorAll('col');
            const widths: number[] = [];
            
            cols.forEach(col => {
              const style = col.getAttribute('style');
              const widthMatch = style?.match(/width:\s*([^;]+)/);
              
              if (widthMatch) {
                const widthStr = widthMatch[1].trim();
                
                // Convert to pixels
                // For percentages, we can't know the exact pixel value without table width,
                // so we'll use a reasonable estimate or just store as-is
                if (widthStr.includes('%')) {
                  // Assume a standard table width of 800px for percentage conversion
                  const percent = parseFloat(widthStr);
                  widths.push(Math.round((percent / 100) * 800));
                } else if (widthStr.includes('px')) {
                  widths.push(parseInt(widthStr, 10));
                } else if (widthStr === 'auto') {
                  widths.push(0); // 0 means auto-width in Tiptap
                } else {
                  widths.push(0);
                }
              } else {
                widths.push(0);
              }
            });
            
            // Store widths on the element so TableCell can read them
            if (widths.length > 0 && widths.some(w => w > 0)) {
              element.setAttribute('data-colwidths', JSON.stringify(widths));
            }
          }
          
          return null; // Return null to use default attributes
        },
      },
    ];
  },
});

export default TableWithColgroup;

